import { useQuery } from "@tanstack/react-query";
import { getUser } from "../../api/User";

export const useUser = () => {
  return useQuery({ queryKey: ["user"], queryFn: getUser });
};
